export default __webpack_public_path__ + "static/media/staticLogoText.a2595509.png";